import React from 'react';
import { ArrowRight, Check, Shield } from 'lucide-react';
import FadeIn from './FadeIn';

const TrialCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-[color:var(--primary-50)]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-[color:var(--text-primary)] mb-4">
              Nejlepší je vyzkoušet si Školobot přímo v praxi.
            </h2>
            <p className="text-base md:text-lg text-[color:var(--text-secondary)] max-w-3xl mx-auto leading-relaxed">
              Zjistíte tak, jak funguje nástroj, který je od začátku vyvinutý pro české školství, ne pro obecné použití. Školobot si můžete vyzkoušet přímo na svých školních datech a ve své každodenní práci, ne jen na obecných ukázkách.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1}>
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              {/* Left — benefits */}
              <div>
                <div className="space-y-4">
                  {[
                    'Na vyžádání zpřístupníme i více trial licencí pro celý tým',
                    'Vyzkoušíte si vše na vlastních školních dokumentech',
                    'Plný přístup ke všem funkcím po dobu trialu',
                    'Bez platební karty, bez automatického prodloužení',
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <div className="w-5 h-5 rounded-full bg-[color:var(--primary-500)] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-white" />
                      </div>
                      <span className="text-sm text-[color:var(--text-primary)]">{item}</span>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-[color:var(--text-muted)] mt-4">
                  Zkušební verze zahrnuje balíček kreditů, které lze využít bez omezení. Po vyčerpání se kredity automaticky nedoplňují.
                </p>
              </div>

              {/* Right — CTA + MŠMT */}
              <div className="flex flex-col gap-5">
                <a href="https://app.skolobot.cz/register" target="_blank" rel="noopener noreferrer">
                  <button className="w-full bg-[color:var(--primary-500)] hover:bg-[color:var(--primary-600)] text-white px-8 py-5 rounded-2xl font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 text-lg">
                    Vyzkoušet zdarma
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </a>

                <a href="/#webinar">
                  <button className="w-full bg-white border-2 border-[color:var(--primary-500)] text-[color:var(--primary-600)] px-8 py-4 rounded-2xl font-semibold hover:bg-[color:var(--primary-50)] transition-all flex items-center justify-center gap-3">
                    Webinář zdarma
                  </button>
                </a>

                <div className="bg-[color:var(--primary-50)] rounded-xl p-4 flex items-start gap-3">
                  <Shield className="w-5 h-5 text-[color:var(--primary-600)] flex-shrink-0 mt-0.5" />
                  <p className="text-xs text-[color:var(--text-secondary)] leading-relaxed">
                    <strong className="text-[color:var(--text-primary)]">Lze hradit jako učební pomůcku.</strong> Školobot odpovídá metodickému výkladu MŠMT „Digitální technologie jako učební pomůcka" — pořízení lze za splnění podmínek metodiky hradit z veřejných prostředků podle § 160 školského zákona.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default TrialCTA;
